import { render, staticRenderFns } from "./MobileSelectedCourse.vue?vue&type=template&id=04b73ef8&scoped=true&"
import script from "./MobileSelectedCourse.vue?vue&type=script&lang=ts&"
export * from "./MobileSelectedCourse.vue?vue&type=script&lang=ts&"
import style0 from "./MobileSelectedCourse.vue?vue&type=style&index=0&id=04b73ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b73ef8",
  null
  
)

export default component.exports